import { render, staticRenderFns } from "./SpotFolderDialog.vue?vue&type=template&id=2d6809c4&"
import script from "./SpotFolderDialog.vue?vue&type=script&lang=js&"
export * from "./SpotFolderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports